import { Lock } from "lucide-react";
// ** Third Party
import PropTypes from "prop-types";

import OptionCardField from "@components/fields/option-card-field";
import SelectField from "@components/fields/select-field";
import LoadingButton from "@components/ui-components/loading-button";
import { FREQUENCY_OPTIONS, KYC_WINDOW_OPTIONS } from "@constants/panel/common";
import { PAYMENT_MODEL_CARDS } from "../misc/constants";
import SetupQuestion from "./setup-question";

// The setup answers, in the order the API takes them. The debit-note question
// is managed-payout only — a self-payout brand pays its publishers directly, so
// no debit note is ever raised against it.
const BrandSetupForm = ({ control, errors, isValid, loading, showDebitNoteFrequency, onSubmit }) => (
    <form onSubmit={onSubmit} className="mt-8 rounded-xl border border-gray-200 bg-white p-6 shadow-sm">
        <SetupQuestion step={1} title="How do you want to pay publishers?">
            <OptionCardField
                control={control}
                name="payment_model"
                options={PAYMENT_MODEL_CARDS}
                errors={errors} />
        </SetupQuestion>

        {/* Both selects share a row; on self payout the KYC one keeps its column
            and the debit-note column is simply absent. `items-end` keeps the two
            controls on the same line when one heading wraps and the other doesn't. */}
        <div className="mt-8 grid gap-6 sm:grid-cols-2 sm:items-end">
            <SetupQuestion
                step={2}
                title="How long do publishers have to complete KYC?"
                description="Payouts are held until a publisher completes KYC within this window.">
                <SelectField
                    control={control}
                    name="kyc_window"
                    options={KYC_WINDOW_OPTIONS}
                    placeholder="Select a window"
                    className="mt-3"
                    errors={errors} />
            </SetupQuestion>

            {showDebitNoteFrequency && (
                <SetupQuestion
                    step={3}
                    title="How often should debit notes be raised?"
                    description="Nook Pay raises a debit note against you on this cycle.">
                    <SelectField
                        control={control}
                        name="debit_note_frequency"
                        options={FREQUENCY_OPTIONS}
                        placeholder="Select a frequency"
                        className="mt-3"
                        errors={errors} />
                </SetupQuestion>
            )}
        </div>

        <div className="mt-4 flex items-start gap-2 rounded-lg border border-warning/40 bg-warning/10 p-3 text-sm text-warning-foreground">
            <Lock className="mt-0.5 h-4 w-4 shrink-0" />
            <span>This can&apos;t be changed once saved. Contact Nook Ops if you need to update it later.</span>
        </div>

        <LoadingButton
            type="submit"
            block
            size="lg"
            className="mt-6"
            disabled={!isValid}
            loading={loading}
            loadingText="Saving…"
            text="Continue" />
    </form>
);

BrandSetupForm.propTypes = {
    control               : PropTypes.any.isRequired,
    errors                : PropTypes.object,
    isValid               : PropTypes.bool,
    loading               : PropTypes.bool,
    showDebitNoteFrequency: PropTypes.bool,
    onSubmit              : PropTypes.func.isRequired
};

export default BrandSetupForm;
